<script>
import ComponentModal from "./addInfo_Modal.vue";
import bus from "../EventBus.js";
export default {
  components: {
    ComponentModal,
  },
  data() {
    return {
      objectMerchandiseData: [],
      buyPrice: "",
    };
  },
  methods: {
    // 顯示新增後的資料
    showMerchandiseData(merchandiseData) {
      /* 
        Object.assign 能處理深度，只有一層的物件，沒辦法做到真正的深拷貝(Deep Copy)
        深拷貝的作法 1) jQuery 的 $.extend 2) lodash 的 _.cloneDeep 
        參考網址:https://kanboo.github.io/2018/01/27/JS-ShallowCopy-DeepCopy/ 
      */
      this.copy = Object.assign({}, merchandiseData);
      this.objectMerchandiseData.push(this.copy);
      this.copy = "";
      console.log("on");
      console.log(this.objectMerchandiseData);
    },
    /* 
      click info, .emit 商品資訊到 addInfo_Modal.vue
      click 額外傳入索引(index), 用於 emit 回來時 splice(編輯/取代)原本的資料
    */
    clickMerchandiseData(merchandiseData, index) {
      merchandiseData.index = index;
      bus.emit("clickMerchandiseData", merchandiseData);
      console.log("emit checkMerchandiseData", merchandiseData, index);
    },
    /*
      emit 回來的資料先深拷貝出來, 然後 splice 更新資料
      splice(start, 0=new;1=取代, new/取代內容)
    */
    edit(merchandiseData) {
      this.copy = Object.assign({}, merchandiseData);
      this.objectMerchandiseData.splice(this.copy.index, 1, this.copy);
      console.log(this.objectMerchandiseData);
    },
    deleteMerchandiseData(index) {
      this.objectMerchandiseData.splice(index, 1);
    },
  },
  watch: {
    objectMerchandiseData: {
      handler() {
        this.buyPrice = 0;
        this.objectMerchandiseData.forEach(
          (e) =>
            (this.buyPrice =
              Number(this.buyPrice) + Number(e.merchandiseTotalPrice))
        );
      },
      deep: true,
    },
  },
  computed: {
    calculateBuy() {
      return this.objectMerchandiseData.forEach(
        (e) => (this.buyPrice += e.merchandiseTotalPrice)
      );
    },

    // calculateSell() {},
    // calculateTotal() {},
  },
  created() {
    // 監聽新增資料的 emit 事件, 然後執行 showMerchandiseData() 顯示資料
    bus.on("addMerchandiseData", this.showMerchandiseData);
    // 監聽編輯資料的 emit 事件, 然後執行 edit() 編輯資料
    bus.on("editedMerchandiseData", this.edit);
  },
};
</script>

<template>
  <header class="navbar-top" style="padding-right: 30px">
    <span>購買明細</span>
    <div class="input-group" style="width: 30%">
      <input
        type="text"
        name="datefilter"
        class="form-control"
        placeholder="選擇日期區間"
        aria-label="選擇日期區間"
        aria-describedby="button-addon2"
        value=""
      />
      <button
        class="btn btn-outline-primary material-icons align-middle"
        type="button"
        id="button-addon2"
      >
        search
      </button>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary material-icons align-middle"
      data-bs-toggle="modal"
      data-bs-target="#myModal"
    >
      add
    </button>
  </header>

  <section class="content">
    <div class="content-header">
      <span class="content-header-date">2020-02</span>
      <span class="content-header-cost">購買金額： {{ this.buyPrice }}</span>
      <span class="content-header-income">賣出金額： sum(賣出總金額)</span>
      <span class="content-header-sum">total： 購買金額-賣出金額</span>
    </div>
    <hr />
    <div class="table-responsive">
      <table
        class="table align-middle"
        v-for="(Data, index) in objectMerchandiseData"
        :key="Data"
      >
        <thead>
          <tr>
            <th>商品圖片</th>
            <th>購買總金額</th>
            <th>賣出總金額</th>
            <th>盈餘</th>
            <th>詳細資訊</th>
            <th>刪除</th>
          </tr>
        </thead>
        <tbody>
          <tr class="align-middle">
            <td>
              <img
                src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
                alt=""
              />
            </td>
            <td>{{ Data.merchandiseTotalPrice }}</td>
            <td>新增沒有賣出價啦</td>
            <td>{{ Data }}</td>
            <td>
              <button
                class="btn btn-outline-primary align-middle"
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                @click="clickMerchandiseData(Data, index)"
              >
                info
              </button>
            </td>
            <td>
              <button
                class="btn btn-outline-primary align-middle"
                @click="deleteMerchandiseData(index)"
              >
                del
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="display: flex; justify-content: space-around; flex-wrap: wrap">
      <div
        style="
          padding: 5px;
          background: #ffffff90;
          border-radius: 2%;
          width: 300px;
          height: 350px;
          box-shadow: 0 10px 16px 0 rgb(0 0 0 / 20%),
            0 6px 20px 0 rgb(0 0 0 / 19%);
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        "
      >
        <!-- img -->
        <div style="display: flex; justify-content: center">
          <img
            width="90%"
            src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
            alt=""
            style="border-radius: 2%; position: relative"
          />
        </div>

        <!-- 底部 -->
        <div>
          <div style="display: flex; justify-content: space-around">
            <span style="color: red">購入: $500</span>
            <span style="color: green">賣出: $300</span>
          </div>
          <div
            class="text-center"
            style="
              margin: 0px auto;
              width: 80%;
              padding-top: 10px;
              font-size: 1.2rem;
              border-top: 1px solid black;
            "
          >
            盈餘: $200
          </div>
        </div>
      </div>
      <div
        style="
          padding: 5px;
          background: #ffffff90;
          border-radius: 2%;
          width: 300px;
          box-shadow: 0 10px 16px 0 rgb(0 0 0 / 20%),
            0 6px 20px 0 rgb(0 0 0 / 19%);
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        "
      >
        <!-- img -->
        <div style="display: flex; justify-content: center">
          <img
            width="90%"
            src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
            alt=""
            style="border-radius: 2%"
          />
        </div>
        <!-- 底部 -->
        <div>
          <div style="display: flex; justify-content: space-around">
            <span style="color: red">購入: $500</span>
            <span style="color: green">賣出: $300</span>
          </div>
          <div
            class="text-center"
            style="
              margin: 0px auto;
              width: 80%;
              padding-top: 10px;
              font-size: 1.2rem;
              border-top: 1px solid black;
            "
          >
            盈餘: $200
          </div>
        </div>
      </div>
      <div
        style="
          padding: 5px;
          background: #ffffff90;
          border-radius: 2%;
          width: 300px;
          box-shadow: 0 10px 16px 0 rgb(0 0 0 / 20%),
            0 6px 20px 0 rgb(0 0 0 / 19%);
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        "
      >
        <!-- img -->
        <div style="display: flex; justify-content: center">
          <img
            width="90%"
            src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
            alt=""
            style="border-radius: 2%"
          />
        </div>
        <!-- 底部 -->
        <div>
          <div style="display: flex; justify-content: space-around">
            <span style="color: red">購入: $500</span>
            <span style="color: green">賣出: $300</span>
          </div>
          <div
            class="text-center"
            style="
              margin: 0px auto;
              width: 80%;
              padding-top: 10px;
              font-size: 1.2rem;
              border-top: 1px solid black;
            "
          >
            盈餘: $200
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br /><br />
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
          <tr>
            <th>商品圖片</th>
            <th>購買總金額</th>
            <th>賣出總金額</th>
            <th>盈餘</th>
          </tr>
        </thead>
        <tbody>
          <tr class="align-middle">
            <td>
              <img
                src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
                alt=""
              />
            </td>
            <td>100</td>
            <td>50</td>
            <td>50</td>
            <td><button class="btn btn-outline-primary">info</button></td>
          </tr>
        </tbody>
        <tbody>
          <tr class="align-middle">
            <td>
              <img
                src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
                alt=""
              />
            </td>
            <td>100</td>
            <td>50</td>
            <td>50</td>
            <td><button class="btn btn-outline-primary">info</button></td>
          </tr>
        </tbody>
        <tbody>
          <tr class="align-middle">
            <td>
              <img
                src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
                alt=""
              />
            </td>
            <td>100</td>
            <td>50</td>
            <td>50</td>
            <td><button class="btn btn-outline-primary">info</button></td>
          </tr>
        </tbody>
        <tbody>
          <tr class="align-middle">
            <td>
              <img
                src="https://img.ltn.com.tw/Upload/news/600/2019/03/30/phpUCF6ub.jpg"
                alt=""
              />
            </td>
            <td>100</td>
            <td>50</td>
            <td>50</td>
            <td><button class="btn btn-outline-primary">info</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
  <footer class="footer"></footer>
  <ComponentModal></ComponentModal>
</template>

<style lang="css">
.content-header {
  display: flex;
}
.content-header * {
  flex: 1;
}

.content-header-cost {
  color: red;
}
.content-header-income {
  color: rgb(3, 150, 3);
}

td > img {
  width: 200px;
  height: 150px;
}

img:hover {
  filter: brightness(0.5);
  cursor: pointer;
  transform: scale(1.1);
  transition: 1s;
}
</style>
